import React from 'react';

import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CreateStudyModalOptionalParams} from 'studies/sidepanel/NewStudyDropdown';
import {
  AssayDevelopmentStudyState,
  StudySchema,
  TypedStudyAdapter,
} from 'studies/typed/utils/TypedStudyTypes';

import MultiProcedureRunOverview from '../shared/MultiProcedureRunOverview';
import MultiProcedureRunOverviewTabContents from '../shared/MultiProcedureRunOverviewTabContents';

export const AssayDevelopmentStudyAdapter: TypedStudyAdapter<
  never,
  'processDevInformation',
  AssayDevelopmentStudyState
> = {
  type: StudyType.ASSAY_DEVELOPMENT,
  experimentKey: 'processDevInformation',

  isMultiProcedureRunEnabled: true,

  isMultiBatchEnabled: false,

  isMultiConditionEnabled: true,

  isNotificationSchedulesEnabled: false,

  isUnitOperationInstanceLinkingEnabled: true,

  isVisualizationEnabled: true,

  allowReturnToDesignPhase: false,

  allowRequireDesignApproval: false,

  modalOptions: (stepKey: never) => ({}),

  getButtonsByStep() {
    return null;
  },

  renderMetadataSection(state: AssayDevelopmentStudyState) {
    return <></>;
  },

  getSteps: () => [],

  renderStep(key: never) {},

  useTypedStudyState(this: void, studySchema: StudySchema, initialValues: CreateStudyModalOptionalParams) {
    return {experimentParam: null};
  },

  getPerformanceMetadata(state: AssayDevelopmentStudyState) {
    return {};
  },

  getAnalyticsMetadata(state: AssayDevelopmentStudyState) {
    return {};
  },
  creation: {
    async: false,
    experimentParamRequired: false,
  },
  design: {
    ui: {
      tab: null,
    },
  },
  overview: {
    ui: {
      tab: MultiProcedureRunOverviewTabContents,
      design: null,
      execution: MultiProcedureRunOverview,
    },
  },
  review: {
    llm: {
      enabled: false,
    },
  },
};
